import api from './axios';

/**
 * Get documents for a property or unit
 * @param {number} propertyId - Property ID (optional)
 * @param {number} unitId - Unit ID (optional)
 * @returns {Promise}
 */
export const getDocuments = async (propertyId = null, unitId = null) => {
  const params = new URLSearchParams();
  if (propertyId) params.append('property_id', propertyId);
  if (unitId) params.append('unit_id', unitId);

  const response = await api.get(`/api/documents?${params.toString()}`);
  return response.data;
};

/**
 * Upload documents
 * @param {FormData} formData - FormData containing files, names, categories, property_id/unit_id
 * @returns {Promise}
 */
export const uploadDocuments = async (formData) => {
  const response = await api.post('/api/documents', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

/**
 * Delete a document
 * @param {number} documentId - Document ID
 * @returns {Promise}
 */
export const deleteDocument = async (documentId) => {
  const response = await api.delete(`/api/documents/${documentId}`);
  return response.data;
};

/**
 * Get document count for a property
 * @param {number} propertyId - Property ID
 * @returns {Promise}
 */
export const getPropertyDocumentCount = async (propertyId) => {
  const response = await api.get(`/api/properties/${propertyId}/documents/count`);
  return response.data;
};

/**
 * Get document count for a unit
 * @param {number} unitId - Unit ID
 * @returns {Promise}
 */
export const getUnitDocumentCount = async (unitId) => {
  const response = await api.get(`/api/units/${unitId}/documents/count`);
  return response.data;
};

/**
 * Update document (name/category)
 * @param {number} documentId - Document ID
 * @param {object} data - Update data (name, category)
 * @returns {Promise}
 */
export const updateDocument = async (documentId, data) => {
  const response = await api.put(`/api/documents/${documentId}`, data);
  return response.data;
};
